var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Renderer2 } from '@angular/core';
import { GameHostComponent } from '../game-host/game-host.component';
import { SocketService } from '../shared/services/socket.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageType } from '../shared/model/message-type';
import { GameStatus } from '../shared/model/game-status';
import { SpinnerService } from '../shared/services/spinner.service';
import { WindowsService } from '../shared/services/windows.service';
var PageTelestrationsHostComponent = /** @class */ (function (_super) {
    __extends(PageTelestrationsHostComponent, _super);
    function PageTelestrationsHostComponent(socketService, cookieService, router, resolver, renderer, spinnerService, windowService) {
        var _this = _super.call(this, socketService, cookieService, router, resolver, renderer, spinnerService, windowService) || this;
        _this.gameResults = [];
        _this.gamePrefix = 'P';
        return _this;
    }
    PageTelestrationsHostComponent.prototype.hostMessageHandler = function (message) {
        if (message.action === MessageType.Host) {
            this.connectedUsers = Object.values(message.content.users);
            this.avatarWidth = "calc(" + Math.floor(100 / this.connectedUsers.length) + "% - 20px)";
            if (message.content.status === GameStatus.Waiting) {
                this.gameId = message.content.id;
                this.cookieService.set('gameId', this.gameId, 1, '/');
            }
            else if (message.content.status === GameStatus.Complete) {
                var rounds = message.content.rounds;
                this.gameResults = [];
                for (var username in rounds) {
                    if (rounds[username]) {
                        for (var i = 1; i < rounds[username].length; i++) {
                            var round = {
                                name: username,
                                originalWord: rounds[username][0].answer,
                                artist: rounds[username][i].artist,
                                isDrawing: rounds[username][i].type === 'draw',
                                content: rounds[username][i].answer
                            };
                            this.gameResults.push(round);
                        }
                    }
                }
            }
        }
    };
    return PageTelestrationsHostComponent;
}(GameHostComponent));
export { PageTelestrationsHostComponent };
